import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Input from "../../inputs/inputs";
import { Beat } from "../../../plugins/spinners.plugin";
import { cleanInput } from "../../../helpers/cleanInput";
import successHandler from "../../../handlers/successHandler";
import {
  storePaymentInstrument,
  getMyPaymentInstruments,
} from "../../../redux/paymentInstrument/paymentInstrumentActions";

const months = [
  { title: "January", value: "01" },
  { title: "February", value: "02" },
  { title: "March", value: "03" },
  { title: "April", value: "04" },
  { title: "May", value: "05" },
  { title: "June", value: "06" },
  { title: "July", value: "07" },
  { title: "August", value: "08" },
  { title: "September", value: "09" },
  { title: "October", value: "10" },
  { title: "November", value: "11" },
  { title: "December", value: "12" },
];

export default function CreateCardForm({ onClose }) {
  const dispatch = useDispatch();

  const { creating } = useSelector((state) => state.paymentInstrument);

  const [submitted, setSubmitted] = useState(false);
  const [input, setInput] = useState({
    type: "card",
    card_number: "",
    expiration_date: "",
    cvv: "",
  });
  const [expiryMonth, setExpiryMonth] = useState("");
  const [expiryYear, setExpiryYear] = useState("");
  const { type, card_number, cvv } = input;

  const handleChange = (e) => {
    const { name, value } = e.target;
    e.preventDefault();
    setInput({ ...input, [name]: value });
  };

  const handleMonthChange = (e) => {
    const month = e.target.value;
    setExpiryMonth(month);
    if (month && expiryYear) {
      setInput({ ...input, expiration_date: `${month}/${expiryYear}` });
    }
  };

  const handleYearChange = (e) => {
    const year = e.target.value;
    setExpiryYear(year);
    if (expiryMonth && year) {
      setInput({ ...input, expiration_date: `${expiryMonth}/${year}` });
    }
  };

  // Generate array of years (current year + 20 years)
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 21 }, (_, i) => currentYear + i);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);

    if (type && card_number && expiryMonth && expiryYear && cvv) {
      const payload = {
        type,
        card_number,
        expiration_date: `${expiryMonth}/${expiryYear}`,
        cvv,
      };

      cleanInput(payload);

      try {
        const response = await dispatch(storePaymentInstrument(payload));
        if (response) {
          successHandler(response, true);
          // Refresh the payment instruments list
          await dispatch(getMyPaymentInstruments());
          // Close the modal
          if (onClose) {
            onClose();
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {/* <div className="mt-6">
        <Input.Label
          title={"Card Name"}
          type="text"
          name="name"
          id="name"
          className="w-full border border-[#E4E4F3] focus-within:border-primary focus:border-primary focus:ring-0 sm:text-sm"
          placeholder="Enter card name"
          onChange={handleChange}
        />
        {submitted && (
          <div className="text-xs text-red-500">Recipient name is required</div>
        )}
      </div> */}

      <div className="mt-6">
        <Input.Label
          title={"Card Number"}
          type="text"
          name="card_number"
          id="card_number"
          className="w-full border border-[#E4E4F3] focus-within:border-primary focus:border-primary focus:ring-0 sm:text-sm"
          placeholder="Enter card number"
          onChange={handleChange}
        />
        {submitted && !card_number && (
          <div className="text-xs text-red-500">Card number is required</div>
        )}
      </div>

      <div className="mt-6 grid grid-cols-2 gap-4">
        <div>
          <Input.Select
            title={"Expiry Month"}
            name="expiry_month"
            id="expiry_month"
            className="w-full border border-[#E4E4F3] focus-within:border-primary focus:border-primary focus:ring-0 sm:text-sm"
            htmlFor={"expiry_month"}
            value={expiryMonth}
            onChange={handleMonthChange}
          >
            <option value="">Select expiry month</option>
            {months.map((month, i) => (
              <option key={i} value={month?.value}>
                {month?.title}
              </option>
            ))}
          </Input.Select>
          {submitted && !expiryMonth && (
            <div className="text-xs text-red-500">Expiry month is required</div>
          )}
        </div>

        <div>
          <Input.Select
            title={"Expiry Year"}
            name="expiry_year"
            id="expiry_year"
            className="w-full border border-[#E4E4F3] focus-within:border-primary focus:border-primary focus:ring-0 sm:text-sm"
            htmlFor={"expiry_year"}
            value={expiryYear}
            onChange={handleYearChange}
          >
            <option value="">Select expiry year</option>
            {years.map((year, i) => (
              <option key={i} value={year}>
                {year}
              </option>
            ))}
          </Input.Select>
          {submitted && !expiryYear && (
            <div className="text-xs text-red-500">Expiry year is required</div>
          )}
        </div>
      </div>

      <div className="mt-2">
        <Input.Label
          title={"CVV"}
          type="text"
          name="cvv"
          id="cvv"
          className="w-full border border-[#E4E4F3] focus-within:border-primary focus:border-primary focus:ring-0 sm:text-sm"
          placeholder="Enter cvv"
          onChange={handleChange}
        />
        {submitted && !cvv && (
          <div className="text-xs text-red-500">Cvv is required</div>
        )}
      </div>
      <div>
        <button
          type="submit"
          disabled={creating}
          className=" mt-5 w-full inline-flex justify-center  h-14  rounded-md border border-transparent shadow-sm px-4 py-4 bg-primary text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500  sm:mt-6 sm:text-sm"
        >
          {creating ? <Beat color={"#ffffff"} /> : "Save New Card"}
        </button>
      </div>
    </form>
  );
}
